import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import { useEffect, useRef, useState } from "react";
import { isNotUndefined, isNotUndefinedOrNull, isUndefinedOrNull, showGoogleAds } from "../FunctionsCore";
import { addToRenderableData, classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import AdComponentStyles from "./AdComponentStyles.module.scss";
import { useGoogleAdAvailability } from "./googleAdAvailability";
const styles = AdComponentStyles;
const classCombiner = classCombinerFromPrefix("5f2bfcebc321084d");
const getWindowGoogletag = () => window["googletag"];
const useOnScreen = (reference) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const observer = new IntersectionObserver((int) => setIsIntersecting(int[0].isIntersecting));
    useEffect(() => {
        observer.observe(reference.current);
        return () => observer.disconnect();
    }, []);
    return isIntersecting;
};
const Ad = (properties) => {
    const [addLoaded, setAddLoaded] = useState(false);
    const referenceObject = useRef(null);
    const adDataWithAdSizeParsed = properties.adDataWithAdSizeParsed;
    const adDivId = adDataWithAdSizeParsed.adDivId;
    const height = adDataWithAdSizeParsed.height;
    const width = adDataWithAdSizeParsed.width;
    const onScreen = useOnScreen(referenceObject);
    const loadAdd = () => {
        setAddLoaded(true);
        properties.windowGoogletag.cmd.push(() => {
            var _a;
            const newWindowGoogletag = getWindowGoogletag();
            const pubads = newWindowGoogletag.pubads();
            (_a = newWindowGoogletag.defineSlot(adDataWithAdSizeParsed.adUnitPath, [width, height], adDivId)) === null || _a === void 0 ? void 0 : _a.addService(pubads);
            pubads.enableSingleRequest();
            newWindowGoogletag.enableServices();
            newWindowGoogletag.display(adDivId);
        });
    };
    useEffect(() => {
        if (!adDataWithAdSizeParsed.lazyLoadAd) {
            loadAdd();
        }
    }, []);
    if (onScreen && !addLoaded) {
        loadAdd();
    }
    return _jsx("div", Object.assign({ className: cx(classCombiner(styles, "content")) }, { children: _jsx("div", { className: cx(classCombiner(styles, "ad"), adDataWithAdSizeParsed.heightWidthClassName), id: adDivId, ref: referenceObject }) }));
};
const AdComponent = (properties) => {
    const adDataWithAdSizeParsed = properties.adDataWithAdSizeParsed;
    const [advertisingConsentGiven, setAdvertisingConsentGiven] = useState(false);
    const addAvailable = useGoogleAdAvailability();
    const [windowGoogletag, setWindowGoogletag] = useState(false);
    useEffect(() => {
        const displayGoogleAds = () => {
            if (showGoogleAds()) {
                setAdvertisingConsentGiven(true);
                const windowElement = getWindowGoogletag();
                const windowGoogletagRef = isNotUndefined(windowElement) ? windowElement : { "cmd": [] };
                setWindowGoogletag(windowGoogletagRef);
            }
        };
        if (addAvailable) {
            displayGoogleAds();
        }
    }, [addAvailable]);
    return ((isUndefinedOrNull(adDataWithAdSizeParsed) || !advertisingConsentGiven)
        ? _jsx(_Fragment, {})
        : _jsx(Ad, { adDataWithAdSizeParsed: adDataWithAdSizeParsed, windowGoogletag: windowGoogletag }));
};
const getAdDataWithAdSizeParsed = (adComponentParameter) => {
    const { adData, properties } = adComponentParameter;
    const { lazyLoadAd, spacingTop } = properties;
    const windowElement = getWindowGoogletag();
    const windowGoogletag = isNotUndefined(windowElement) ? windowElement : { "cmd": [] };
    const adDataWithAdSizeParsedArray = adData.map((sk) => {
        // TODO
        const height = window.Number(sk.adHeight);
        const width = window.Number(sk.adWidth);
        const marginTop = window.Number(spacingTop);
        const marginBottom = window.Number(spacingTop);
        const AdDataWithAdSizeParsed = Object.assign(Object.assign({}, sk), { "height": height, "heightWidthClassName": css({
                "height": `${height}px`,
                "marginBottom": `${marginBottom}px !important`,
                "marginTop": `${marginTop}px !important`,
                "width": `${width}px`
            }), "lazyLoadAd": lazyLoadAd, "width": width });
        return AdDataWithAdSizeParsed;
    });
    const goal = window.innerWidth;
    let adDataWithAdSizeParsed;
    if (window.Array.isArray(adDataWithAdSizeParsedArray) && adDataWithAdSizeParsedArray.length > 0) {
        adDataWithAdSizeParsed = adDataWithAdSizeParsedArray.reduce((previous, current) => {
            // TODO
            const currentAdWidthNumber = window.Number(current.adWidth);
            const previousAdWidthNumber = window.Number(previous.adWidth);
            const currentAdWidthNumberDifference = window.Math.abs(currentAdWidthNumber - goal);
            const previousAdWidthNumberDifference = window.Math.abs(previousAdWidthNumber - goal);
            if (currentAdWidthNumberDifference === previousAdWidthNumberDifference) {
                return currentAdWidthNumber > previousAdWidthNumber ? current : previous;
            }
            else {
                return previousAdWidthNumberDifference < currentAdWidthNumberDifference ? previous : current;
            }
        });
    }
    return { "adDataWithAdSizeParsed": adDataWithAdSizeParsed, "goal": goal, "windowGoogletag": windowGoogletag };
};
const adComponent = (renderableData) => {
    const { adDataWithAdSizeParsed, goal, windowGoogletag } = getAdDataWithAdSizeParsed(renderableData.data);
    // TODO
    if (isNotUndefinedOrNull(adDataWithAdSizeParsed) && window.Number(adDataWithAdSizeParsed.adWidth) < goal) {
        renderIdentifierGeneric(AdComponent, addToRenderableData(renderableData, {
            "adDataWithAdSizeParsed": adDataWithAdSizeParsed,
            "goal": goal,
            "windowGoogletag": windowGoogletag
        }));
    }
};
export { AdComponent, adComponent, getAdDataWithAdSizeParsed };
